import { titleDetailsContent } from "./titleDetails";
import { projectContent } from "./projects";
import { applyContent } from "./apply";

export const projectViewContent = {
  titleDetailsContent,
  projectContent,
  applyContent,
};
